(ns nosco.ui.progress
  (:require
   [goog.string :as gstring]
   [goog.string.format]
   [hx.react :refer [defnc]]
   [nosco.i18n.translate :as t]
   [nosco.icons2 :as icons2]
   [nosco.ui.buttons2 :as buttons]
   [nosco.ui.text :as text]
   [nosco.ui.tooltips :as tooltips]))

(defn human-readable-filesize [bytes]
  (let [kb 1024
        mb (* 1024 kb)
        gb (* 1024 mb)
        tb (* 1024 gb)]
    (cond
      (< bytes kb) (str bytes " B")
      (< bytes mb) (gstring/format "%.1f KB" (/ bytes kb))
      (< bytes gb) (gstring/format "%.1f MB" (/ bytes mb))
      (< bytes tb) (gstring/format "%.1f GB" (/ bytes gb))
      :else (gstring/format "%.1f TB" (/ bytes tb)))))

(defnc ProgressBar [{:keys [progress no-text text tooltip size layout no-transition disabled]}]
  [tooltips/WithTooltip {:label tooltip}
   [:div
    {:class ["nosco-progress-bar"
             (when (= :small size) "nosco-progress-bar--size-small")
             (when (= :stacked layout) "nosco-progress-bar--layout-stacked")
             (when no-transition "nosco-progress-bar--no-transition")
             (when disabled "nosco-progress-bar--disabled")]
     :style {"--progress"
             ;; ensure that the very edges are clearly visible
             ;; so always have a min 1% and a max 99% unless it's truly 0 or 100
             (cond
               (zero? progress) 0
               (< 0.99 progress 1) 0.99
               :else (max progress 0.01))}}
    [:div {:class "nosco-progress-bar__base"}
     [:div {:class "nosco-progress-bar__fill"}]]
    (cond
      no-text
      nil

      text
      [:div {:class "nosco-progress-bar__text"}
       text]

      :else
      [:div {:class "nosco-progress-bar__text"}
       (if (< 0.99 progress 1)
         (t/t "99%")
         (t/t "%s%" (gstring/format "%.0f" (* 100.0 progress))))])]])

(defnc UploadProgressItem [{:keys [filename
                                   thumb-src
                                   thumb-icon
                                   filesize
                                   progress-max
                                   progress-value
                                   uploaded?
                                   error
                                   on-retry
                                   on-cancel]}]
  (let [progress (if (and progress-value
                          progress-max
                          (not= progress-max 0))
                   (/ progress-value progress-max)
                   0)]
    [:div {:class "nosco-upload-progress-item"}
     [:div {:class "nosco-upload-progress-item__thumb"}
      (when thumb-src
        [:img {:src thumb-src}])
      (when thumb-icon
        [icons2/Icon {:icon thumb-icon}])]
     [:div {:class "nosco-upload-progress-item__progress"}
      [text/Text {:variant text/Body-Md-Bold
                  :class "nosco-upload-progress-item__filename"}
       filename]
      (cond
        error [text/Text {:variant text/Body-Md-Regular
                          :class ["nosco-upload-progress-item__subtext"
                                  "nosco-upload-progress-item__error"]}
               (if (string? error)
                 error
                 (t/t "Upload failed"))]
        (and uploaded? filesize) [text/Text {:variant text/Body-Md-Regular
                                             :class "nosco-upload-progress-item__subtext"}
                                  (human-readable-filesize filesize)]
        :else [ProgressBar {:progress progress}])]
     (when (and error on-retry)
       [buttons/Button {:variant :icon-light
                        :icon icons2/Refresh-large
                        :on-click on-retry}])
     [buttons/Button {:variant :icon-light
                      :icon icons2/Close-large
                      :on-click on-cancel}]]))

(defnc ProgressList [{:keys [children]}]
  [:div {:class "nosco-progress-list"}
   children])
